import classNames from "classnames";
import { type FC } from "react";
import { MediasLogo, type MediasVariant } from "~/Header/components/TopBar/MediasLogo";
import { CompanyLogo } from "~/common/components/companyLogo/CompanyLogo";
import { userIsPublic, userIsRegistered } from "~/utils/roles";
import classes from "./CustomModalHeader.module.less";

const CustomModalHeader: FC = () => {
  let userRole: MediasVariant;
  if (userIsPublic()) {
    userRole = "general";
  } else if (userIsRegistered()) {
    userRole = "plus";
  } else {
    userRole = "business";
  }

  return (
    <div className={classNames("container scha__logo-header", classes.headerBorder)}>
      <MediasLogo variant={userRole} />
      <div className="scha__company-logo scha__header__logo">
        <CompanyLogo />
      </div>
    </div>
  );
};

export default CustomModalHeader;
